<template>
  <div>
    <p class="font-weight-bold">
        Especifique razón social de la(s) institución(es) (hospital, clínicas, escuelas, etc) en donde se realiza el estudio o especificar si se realiza en hogares o vía electrónica.
    </p>
    <input type="hidden" v-model="stringifySites" name="sites" id="sites">
    <div class="protocol-attachments-container">
      <div class="list-group list-group-bordered mb-3">
        <div class="list-group-header d-flex align-items-center">
          <span class="">{{ sites.length }} {{ sites.length === 1 ? 'Sitio' : 'Sitios'}} {{ sites.length === 1 ? 'Agregado' : 'Agregados'}}</span>
          <div class="ml-auto">
            <div class="d-inline-block">
              <button type="button" title="Add files" data-toggle="modal"
                      data-target="#sites-modal" class="btn btn-light">
                <i class="fas fa-plus-circle mr-2"></i> Agregar sitio
              </button>
            </div>
          </div>
        </div>
        <div v-if="sites && sites.length">
          <div v-for="(site, key) in sites"
               :key="key"
               class="list-group-item">
            <div class="list-group-item-figure">
              <a href="#" class="tile tile-circle bg-info">
                <i class="far fa-hospital"></i>
              </a>
            </div>
            <div class="list-group-item-body">
              <h4 class="list-group-item-title">
                {{ site.name }}
              </h4>
              <p class="list-group-item-text text-truncate">
                {{ site.instance }}
              </p>
            </div>
            <div class="list-group-item-figure align-items-start">
              <div class="dropdown show">
                <button data-toggle="dropdown" class="btn btn-sm btn-icon btn-light"
                        aria-expanded="true">
                  <i class="fa fa-fw fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <div class="dropdown-arrow mr-n1"></div>
                  <button class="dropdown-item"
                          type="button"
                          @click.prevent="editSite(key)">
                    Editar sitio
                  </button>
                  <div class="dropdown-divider"></div>
                  <button type="button"
                          class="dropdown-item"
                          @click.prevent="deleteSite(key)">
                    Eliminar sitio
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <sites-modal ref="sitesModal"
                 @add-site="addSiteToList"
                 @update-site="updateSite"></sites-modal>
  </div>
</template>

<script>
  import SitesModal from './SitesModal'
  import { AlertManager } from '../../../utils/AlertManager'

  export default {
    name: 'SitesList',
    components: {
      SitesModal,
    },
    props: {
      sites: {
        type: Array,
        default: () => ([]),
      },
    },
    data: () => ({ }),
    methods: {
      addSiteToList (site) {
        this.sites.push(site)

        $('#sites-modal').modal('hide')
      },
      deleteSite (index) {
        this.sites.splice(index, 1);

        AlertManager.success('Sitio eliminado correctamente')
      },
      editSite (index) {
        this.$refs.sitesModal.editSite(index, this.sites[index])

        $('#sites-modal').modal('show')
      },
      updateSite (index, site) {
        this.sites.splice(index, 1, site)

        $('#sites-modal').modal('hide')
      }
    },
    computed: {
      stringifySites: function () {
        if (this.sites.length === 0) {
          return null
        }
        
        return JSON.stringify(this.sites)
      }
    },
    mounted () {

    },
  }
</script>
